const newsletter = `
# eBL Newsletter 18

## 8 January 2025

### Fragmentarium

- ATF: A new flag, *No longer visible*, has been introduced. This flag is
  applied to signs or features, such as rulings, that were visible in older
  photographs but have since disappeared. These instances are indicated with a
  circellus (°), for example: \`a-me°-lu\`.
- New feature: Dossiers
- New collections imported:
  -	Nippur photos & records from 1NT to 3NT
  - Chicago ISAC tablet collection
  - NINO Leiden
  - Chester Beatty Library Dublin
  - Trinity College Dublin
  - McGill University Collections, Montreal
- Archaeological information for all IM tablets present in eBL has been
  imported.
- Date: The OB kings of the Uruk and Ešnunna dynasties have been added.
- New links:
  -	digitaleKeilschriftBibliothek, e.g.
  [VAT.10071](https://www.ebl.lmu.de/fragmentarium/VAT.10071)
  - Morgan Library, e.g.
  [MLC.1889](https://www.ebl.lmu.de/fragmentarium/MLC.1889)
- The editions from Y. Levavi, *Administrative Epistolography in the Formative
  Phase of the Neo-Babylonian Empire* (Dubsar 3) have been imported.

### Bibliography

- Updates to Bibliography editor: Entering new references using DOIs, or any
  reference without an id, now creates by default meaningful ids, e.g.
  \`george2003babylonian\`.`

export default newsletter
